import { PaymentTypeResponse } from "../contracts/PaymentTypeResponse";
import { PaymentType } from "../models/PaymentType";

export const mapResponseToPaymentType = (resp: PaymentTypeResponse): PaymentType => ({
  id: resp.id,
  name: resp.name,
  priceAmountMinorUnits: resp.priceAmountMinorUnits,
  currency: resp.currency,
  isActive: resp.isActive,
  dateCreated: resp.dateCreated,
  dateModified: resp.dateModified,
});
